// -----------------------------------------------------------------------------
// Usage:
// private readonly _lock = new AsyncLock();
// ...
// public async doSomething... {
//   try {
//     await this._lock.lock();
//     await this.doCriticalSection();
//   } catch {
//   } finally {
//     this._lock.unlock();
//   }
// }

// ----------------------------------tester----------------------------------------
// const lock = new AsyncLock();
// async function task(name, delay) {
// console.log(`AsyncLock ${name} is waiting for the lock...`);
// await lock.lock();
//     console.log(`AsyncLock ${name} has acquired the lock!`);
//
//     // Simulate some async work
//     await new Promise((res) => setTimeout(res, delay));
//
//     console.log(`AsyncLock ${name} is releasing the lock.`);
//     lock.unlock();
// }
//
// async function main() {
//     task("AsyncLockTask 1", 2000); // Runs first
//     task("Task 2", 1000); // Waits for Task 1 to finish
//     task("Task 3", 500); // Waits for Task 2 to finish
// }
// /// ----------------------------------------------------------------------------

// / ----------------------------------------------------------------------------
export class AsyncLock {
  private _promiseLock: Promise<void> | undefined;
  private _promiseResolver:
    | ((value: void | PromiseLike<void>) => void)
    | undefined;

  private _id: number = 0;

  // ---------------------------------------------------------------------------
  public async lock(): Promise<void> {
    let prevPromiseId = undefined;

    while (this._promiseLock && this._id !== prevPromiseId) {
      prevPromiseId = this._id;
      await this._promiseLock;
    }

    this._id++;
    this._promiseLock = new Promise(resolve => {
      this._promiseResolver = resolve;
    });
  }

  // ---------------------------------------------------------------------------
  public async unlock(): Promise<void> {
    if (!this._promiseResolver) {
      return;
    }

    this._promiseResolver();
    this._promiseResolver = undefined;
    this._promiseLock = undefined;
  }
}
